module.exports = __webpack_public_path__ + "e94473c56116a08907e9e5e167ecce9c.png";